import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddd811ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-div" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "lblTitle" }, "Confirm Sales Note"),
  /*#__PURE__*/_createElementVNode("span", { class: "lblRemark" }, [
    /*#__PURE__*/_createTextVNode("Remarks : For sales No. for which Sales Note has not been issued/ Circulation has not been completed, they will be deleted "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("    on the fourth business day of the month following a month in which all units of the sales No. are shipped.")
  ])
], -1 /* HOISTED */))
const _hoisted_4 = { class: "btn-div" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  id: "detailtbl",
  class: "tbl-div"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"tblTitle-div\" style=\"width:calc(100% - 16px);\" data-v-ddd811ce><table id=\"tblConfirmSalesNoteInfo\" class=\"w-100\" data-v-ddd811ce><tr data-v-ddd811ce><th style=\"width:3%;\" data-v-ddd811ce></th><th style=\"width:8%;\" data-v-ddd811ce>Sales No.</th><th style=\"width:5%;\" data-v-ddd811ce>NO.</th><th style=\"width:10%;\" data-v-ddd811ce>Country Name</th><th style=\"width:20%;\" data-v-ddd811ce>Distributor Name</th><th style=\"width:8%;\" data-v-ddd811ce>Production Month</th><th style=\"width:16%;\" data-v-ddd811ce>Status</th></tr></table></div>", 1)
const _hoisted_10 = {
  id: "tblbodydiv",
  class: "tblbody-div"
}
const _hoisted_11 = {
  id: "tblConfirmSalesNoteInfo",
  class: "w-100"
}
const _hoisted_12 = { id: "tbltbody" }
const _hoisted_13 = { style: {"width":"3%"} }
const _hoisted_14 = ["onUpdate:modelValue", "disabled", "onClick"]
const _hoisted_15 = { style: {"width":"8%","text-align":"left"} }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/PDFICON.png",
  alt: "image"
}, null, -1 /* HOISTED */))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { style: {"width":"5%"} }
const _hoisted_20 = { style: {"width":"10%"} }
const _hoisted_21 = { style: {"width":"20%"} }
const _hoisted_22 = { style: {"width":"8%"} }
const _hoisted_23 = { style: {"width":"16%"} }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel"
  }, " Status Details "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "modalCancel",
    class: "btn btn-primarydata close-btn",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */))
const _hoisted_30 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left"}
}
const _hoisted_31 = { class: "tblbody-div-modal" }
const _hoisted_32 = { class: "row-div-name" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Distributor Name", -1 /* HOISTED */))
const _hoisted_34 = { class: "lbl-dada-display" }
const _hoisted_35 = { class: "row-div" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Sales No", -1 /* HOISTED */))
const _hoisted_37 = { class: "lbl-dada-display" }
const _hoisted_38 = { class: "row-div" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "lbl-Search-Left" }, "Status", -1 /* HOISTED */))
const _hoisted_40 = { class: "lbl-dada-display" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_43 = { class: "table-detail-modal" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Issuer", -1 /* HOISTED */))
const _hoisted_45 = { width: "30%" }
const _hoisted_46 = { width: "35%" }
const _hoisted_47 = { width: "10%" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "SMC Confirmer", -1 /* HOISTED */))
const _hoisted_49 = { width: "30%" }
const _hoisted_50 = { width: "35%" }
const _hoisted_51 = { width: "10%" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "SMC Approver", -1 /* HOISTED */))
const _hoisted_53 = { width: "30%" }
const _hoisted_54 = { width: "35%" }
const _hoisted_55 = { width: "10%" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer1", -1 /* HOISTED */))
const _hoisted_57 = { width: "30%" }
const _hoisted_58 = { width: "35%" }
const _hoisted_59 = { width: "10%" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer2", -1 /* HOISTED */))
const _hoisted_61 = { width: "30%" }
const _hoisted_62 = { width: "35%" }
const _hoisted_63 = { width: "10%" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer3", -1 /* HOISTED */))
const _hoisted_65 = { width: "30%" }
const _hoisted_66 = { width: "35%" }
const _hoisted_67 = { width: "10%" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer4", -1 /* HOISTED */))
const _hoisted_69 = { width: "30%" }
const _hoisted_70 = { width: "35%" }
const _hoisted_71 = { width: "10%" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Confirmer5", -1 /* HOISTED */))
const _hoisted_73 = { width: "30%" }
const _hoisted_74 = { width: "35%" }
const _hoisted_75 = { width: "10%" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { width: "25%" }, "Approver", -1 /* HOISTED */))
const _hoisted_77 = { width: "30%" }
const _hoisted_78 = { width: "35%" }
const _hoisted_79 = { width: "10%" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["Navigation"]),
      _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
      _createVNode($setup["SalesNoteHeaderNavigation"]),
      _createVNode($setup["SalesNoteLinkNavigation"]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary selectAll text-center",
            onClick: $setup.selectAll,
            disabled: $setup.btnSelectAllFlg
          }, "Select All", 8 /* PROPS */, _hoisted_5),
          _hoisted_6,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary ClearAll text-center",
            onClick: $setup.clearAll,
            disabled: $setup.btnClearAllFlg
          }, "Clear All", 8 /* PROPS */, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("tbody", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.confirmSalesNoteInfoList, (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((info.isChecked) = $event),
                        disabled: info.isChkEnabled,
                        onClick: ($event: any) => ($setup.chkCheckEvent(info))
                      }, null, 8 /* PROPS */, _hoisted_14), [
                        [_vModelCheckbox, info.isChecked]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createTextVNode(_toDisplayString(info.salesNo) + " ", 1 /* TEXT */),
                      (info.pdfIconShowFlg)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "pdfLink",
                            onClick: ($event: any) => ($setup.showPDFFile(info))
                          }, _hoisted_18, 8 /* PROPS */, _hoisted_16))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(info.seqNo), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(info.szcntreab_nm), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(info.agn_name), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(info.productionYM.slice(0, 4) + '/' + info.productionYM.slice(4, 6)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_23, [
                      _createElementVNode("a", {
                        class: "inq-a-link",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#showModal",
                        onClick: ($event: any) => ($setup.showModal(info))
                      }, _toDisplayString(info.description), 9 /* TEXT, PROPS */, _hoisted_24)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btnCheckSalesNote text-center",
            disabled: $setup.btnChkSNFlg,
            onClick: $setup.checkSalesNote
          }, "Check Sales Note", 8 /* PROPS */, _hoisted_25)
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.statusData.scan_kdp_approval, (info) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: info.id
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("label", _hoisted_34, _toDisplayString($setup.statusData.distributorName), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("label", _hoisted_37, _toDisplayString(info.salesNo), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("label", _hoisted_40, _toDisplayString(info.status?.status == '5'? '代理店確認待ち' : info.status?.status == '6'? '代理店承認待ち':  info.status?.description), 1 /* TEXT */)
                  ]),
                  _hoisted_41,
                  _hoisted_42,
                  _createElementVNode("table", _hoisted_43, [
                    _createElementVNode("tr", null, [
                      _hoisted_44,
                      _createElementVNode("td", _hoisted_45, _toDisplayString(info.drafterId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_46, _toDisplayString((info.drafterId?.givenName || '') + ' ' + (info.drafterId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(info.issueDate ? info.issueDate.slice(0, 4) + '/' + info.issueDate.slice(4, 6)+ '/' + info.issueDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_48,
                      _createElementVNode("td", _hoisted_49, _toDisplayString(info.smcConfirmerId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_50, _toDisplayString((info.smcConfirmerId?.givenName || '') + ' ' + (info.smcConfirmerId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_51, _toDisplayString(info.smcConfirmDate ? info.smcConfirmDate.slice(0, 4) + '/' + info.smcConfirmDate.slice(4, 6)+ '/' + info.smcConfirmDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_52,
                      _createElementVNode("td", _hoisted_53, _toDisplayString(info.approverId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_54, _toDisplayString((info.approverId?.givenName || '') + ' ' + (info.approverId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_55, _toDisplayString(info.smcApproveDate ? info.smcApproveDate.slice(0, 4) + '/' + info.smcApproveDate.slice(4, 6)+ '/' + info.smcApproveDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_56,
                      _createElementVNode("td", _hoisted_57, _toDisplayString(info.distributorConfirmer1Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_58, _toDisplayString((info.distributorConfirmer1Id?.givenName || '') + ' ' + (info.distributorConfirmer1Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_59, _toDisplayString(info.distributorConfirm1Date ? info.distributorConfirm1Date.slice(0, 4) + '/' + info.distributorConfirm1Date.slice(4, 6)+ '/' + info.distributorConfirm1Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_60,
                      _createElementVNode("td", _hoisted_61, _toDisplayString(info.distributorConfirmer2Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_62, _toDisplayString((info.distributorConfirmer2Id?.givenName || '') + ' ' + (info.distributorConfirmer2Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_63, _toDisplayString(info.distributorConfirm2Date ? info.distributorConfirm2Date.slice(0, 4) + '/' + info.distributorConfirm2Date.slice(4, 6)+ '/' + info.distributorConfirm2Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_64,
                      _createElementVNode("td", _hoisted_65, _toDisplayString(info.distributorConfirmer3Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_66, _toDisplayString((info.distributorConfirmer3Id?.givenName || '') + ' ' + (info.distributorConfirmer3Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_67, _toDisplayString(info.distributorConfirm3Date ? info.distributorConfirm3Date.slice(0, 4) + '/' + info.distributorConfirm3Date.slice(4, 6)+ '/' + info.distributorConfirm3Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_68,
                      _createElementVNode("td", _hoisted_69, _toDisplayString(info.distributorConfirmer4Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_70, _toDisplayString((info.distributorConfirmer4Id?.givenName || '') + ' ' + (info.distributorConfirmer4Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_71, _toDisplayString(info.distributorConfirm4Date ? info.distributorConfirm4Date.slice(0, 4) + '/' + info.distributorConfirm4Date.slice(4, 6)+ '/' + info.distributorConfirm4Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_72,
                      _createElementVNode("td", _hoisted_73, _toDisplayString(info.distributorConfirmer5Id?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_74, _toDisplayString((info.distributorConfirmer5Id?.givenName || '') + ' ' + (info.distributorConfirmer5Id?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_75, _toDisplayString(info.distributorConfirm5Date ? info.distributorConfirm5Date.slice(0, 4) + '/' + info.distributorConfirm5Date.slice(4, 6)+ '/' + info.distributorConfirm5Date.slice(6, 8) : ''), 1 /* TEXT */)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_76,
                      _createElementVNode("td", _hoisted_77, _toDisplayString(info.distributorApproverId?.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_78, _toDisplayString((info.distributorApproverId?.givenName || '') + ' ' + (info.distributorApproverId?.familyName || '')), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_79, _toDisplayString(info.distributorApproveDate ? info.distributorApproveDate.slice(0, 4) + '/' + info.distributorApproveDate.slice(4, 6)+ '/' + info.distributorApproveDate.slice(6, 8) : ''), 1 /* TEXT */)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}